<script setup lang="ts">
import { useCompanyProductsSync } from "@/remote/useCompanyProductsSync";

/** Headless, like TCompanyScopeSync: runs once the router has resolved. */
useCompanyProductsSync();
</script>

<template>
  <!-- nothing to render; this component only refreshes products the host changed -->
</template>
